import { useMutation, useQueryClient } from '@tanstack/react-query'
import { showNotification } from '@mantine/notifications'
import { useOrpc } from './useClient'
import { logError } from '@/utils/errorUtils'

export const tefcaOpenReviewQueryKey = (patientId: string) =>
  ['tefca-open-review', { patientId }] as const

/**
 * Manual Link resolution of a Match Review: calls the TEFCA manual-link
 * endpoint, which writes the HG identifier (plus the candidate's Key
 * Demographics when `updateChart` is set), completes the pending review, and
 * starts the standard historical import.
 */
export function useTefcaManualLink(options?: { onSuccess?: () => void }) {
  const orpc = useOrpc()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.tefcaManualLink.mutationOptions({
      onSuccess: async (_data, variables) => {
        showNotification({
          color: 'green',
          message: 'Patient linked to the TEFCA record. Importing outside records…',
        })
        await queryClient.invalidateQueries({
          queryKey: tefcaOpenReviewQueryKey(variables.patientId),
        })
        options?.onSuccess?.()
      },
      onError: (error) => {
        logError('patient', 'TEFCA manual link', error)
        showNotification({ color: 'red', message: 'Failed to link the patient. Please try again.' })
      },
    }),
  )
}
